import { Description } from "@mui/icons-material";

export const my_skills = {
  strengths: [
    {
      strength: "Strong problem-solving skills and expertise in multiple programming languages.",
    },
    {
      strength: "Proven ability to write maintainable, optimized code.",
    },
    {
      strength: "Focused on delivering quality through rigorous testing and code reviews.",
    },
    {
      strength: "Passionate about continuous learning and staying up-to-date with the latest technologies.",
    },
    {
      strength: "Collaborative team player with excellent communication skills.",
    },
  ],

  tools: [
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      description: "Java",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
      description: "Spring",
    },
    {
      image_url: "https://raw.githubusercontent.com/devicons/devicon/6910f0503efdd315c8f9b858234310c06e04d9c0/icons/quarkus/quarkus-original.svg",
      description: "Quarkus",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      description: "Node.js",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      description: "Express",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nestjs/nestjs-original.svg",
      description: "NestJS",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      description: "Python",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      description: "MongoDB",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
      description: "PostgreSQL",
    },



    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
      description: "Angular",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      description: "React",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
      description: "Redux",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
      description: "Next.js",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg",
      description: "Django",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      description: "TypeScript",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      description: "JavaScript",
    },




    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      description: "HTML5",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      description: "CSS3",
    },




    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
      description: "Docker",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
      description: "Kubernetes",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-line.svg",
      description: "Jenkins",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gitlab/gitlab-original.svg",
      description: "GitLab",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
      description: "GitHub",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      description: "Git",
    },



    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ansible/ansible-original.svg",
      description: "Ansible",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nginx/nginx-original.svg",
      description: "Nginx",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vagrant/vagrant-original.svg",
      description: "Vagrant",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apache/apache-original.svg",
      description: "Apache",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apachekafka/apachekafka-original.svg",
      description: "Kafka",
    },
    {
      image_url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/grafana/grafana-original.svg",
      description: "Grafana",
    },

  ]
};







